import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { Download } from "lucide-react";
import { Link } from "react-router-dom";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

export default function SiteLayout({ children }) {
  const { pathname } = useLocation();
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <AnimatePresence mode="wait">
        <motion.main
          key={pathname}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        >
          {children}
        </motion.main>
      </AnimatePresence>
      <Footer />
      <FloatingWhatsApp />
      <Link
        to="/#download"
        data-testid="sticky-download-mobile"
        className="lg:hidden fixed bottom-4 right-4 z-40 inline-flex items-center gap-2 rounded-full bg-[#FF5A00] hover:bg-[#E65100] text-white px-5 py-3 text-sm font-semibold shadow-xl shadow-orange-500/40"
      >
        <Download className="w-4 h-4" />
        Download
      </Link>
    </>
  );
}
